module.exports = __webpack_public_path__ + "static/media/Corn8R3.c49805fa.png";